module.exports = __webpack_public_path__ + "img/explain_radio.88c6c894.svg";